module.exports = __webpack_public_path__ + "media/ad_designs/wsj-ad-placement-898a6e42.jpg";